import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { awsConfig } from './amplifyConfig';
import './styles/variables.css';
import './styles/authenticator.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

Amplify.configure(awsConfig);

// Title shown above the sign in / sign up form.
const authComponents = {
  Header() {
    return (
      <div className="auth-title">
        <span className="auth-title__emoji" aria-hidden="true">🌱</span>
        <h1 className="auth-title__text">Square Foot Gardener</h1>
      </div>
    );
  },
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    {/* Authenticator shows a login/signup screen; App only renders once signed in. */}
    <Authenticator components={authComponents}>
      {({ signOut, user }) => <App signOut={signOut} user={user} />}
    </Authenticator>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
